export const PENDING_STATUS = 'pending'
export const FINISHED_STATUS = 'finished'
